import { createStructuredSelector } from 'reselect'
import { branch, renderNothing } from 'recompose'

import { Route, withTranslatedMeta, withMeta } from 'i18n/utils'
import { Image } from 'wordpress/components'
import { queryPosts } from 'wordpress/actions'
import { withWordpressLanguage } from 'wordpress/utils'
import { loadOnMount } from 'shared/hoc'

import Archive from './Archive'
import SingleNewsItem from './SingleNewsItem'
import RelatedArticles from './RelatedArticles'
import Header from './Header'
import '../styles/news.scss'

import { backgroundImageSelector, titleSelector, categoriesSelector } from '../selectors'

const $Background = ({ image }) => <Image className="background" image={image} background />

const Background = connect(
    createStructuredSelector({
        image: backgroundImageSelector,
    })
)($Background)

const $Title = ({ title }) => <h1 className="text-center">{title || <T>news.label</T>}</h1>

const Title = connect(
    createStructuredSelector({
        title: titleSelector,
    }),
    withMeta(({ title }) => ({ title }))
)($Title)

const keyFromMatchAndLocation = ({ category, slug }, location) =>
    `${category}-${slug}-${location ? location.search : null}`

const NewsContainer = () => (
    <div id="news" className="container-fluid p-0">
        <Route path="/news/:category?/:slug?" component={Background} />

        <div className="container">
            <Route path="/news/:category?/:slug?" component={Title} />
            <Route
                exact
                path="/news/:category?"
                render={props => (
                    <div>
                        <Header {...props} key={keyFromMatchAndLocation(props.match.params)} />
                        <Archive
                            {...props}
                            uncategorized={!props.match.params.category}
                            key={keyFromMatchAndLocation(props.match.params, props.location)}
                        />
                    </div>
                )}
            />
            <Route
                exact
                path="/news/:category/:slug"
                render={props => (
                    <SingleNewsItem {...props} key={keyFromMatchAndLocation(props.match.params, props.location)} />
                )}
            />
        </div>

        <Route
            exact
            path="/news/:category/:slug"
            render={props => (
                <RelatedArticles
                    {...props}
                    uncategorized={props.match.params.category === 'uncategorized'}
                    key={keyFromMatchAndLocation(props.match.params, props.location)}
                />
            )}
        />
    </div>
)

export default compose(
    withTranslatedMeta('news.label'),
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            categories: categoriesSelector,
        }),
        { queryPosts }
    ),
    loadOnMount('queryPosts', () => ['categories']),
    branch(props => props.categories.length === 0, renderNothing)
)(NewsContainer)
